import {ENDPOINT_ADMIN_TRX_COLLISIONS_LIST} from "../../constants/api";

const CancelablePromise = require('mn-utils/CancelablePromise');
const loopMap = require('mn-utils/loopMap');
const map = require('mn-utils/map');
const {
  apiRequestAdmin,
} = require('../ws');


const MOCK_TRANSACTION_COLLISION = loopMap(100, (i) => {
  return {
    id: '' + (1 + i),
    time: '2021-03-25T15:36:51',
    cc_code: 'ETH',
    cc_amount: 0.004340201,
    sender: 'sender',
    hash: '0x2898ccaa457036807a9669707c8f6bb517480a158ba6d391100a99bef1c58286',
    status: 'InDB',
  };
});


export function apiAdminTransactionCollisionList(params) {
  params = params || {};
  const offset = params.offset || 0;
  const limit = params.limit || 50;
  if (process.env.MOCK) {
    return CancelablePromise.delay(500, {
      list: MOCK_TRANSACTION_COLLISION.slice(offset, offset + limit),
      count: MOCK_TRANSACTION_COLLISION.length,
    });
  }

  return apiRequestAdmin(ENDPOINT_ADMIN_TRX_COLLISIONS_LIST, {
    ...params,
    offset,
    limit,
  }).then((v) => {
    return {
      ...v,
      list: map(v.list, (item) => {
        return {
          ...item,
          id: item.blockchain_id,
          time: item.time_stamp,
        };
      }),
    };
  });
}
